<template>
  <div class="capture-task ml5 mt5">
    <el-form ref="queryForm" class="pagination-table-query-form" :inline="true" @keyup.enter.native="handleFormQuery()">
      <el-form-item label="抓拍服务">
        <el-select v-model.number="tableQueryParams.serviceId" placeholder="请选择抓拍服务">
          <el-option
            v-for="item in servicesIncludeAll"
            :key="item.id"
            :value="item.id"
            :label="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="运行模式">
        <el-select v-model.number="tableQueryParams.runMode" placeholder="请选择运行模式">
          <el-option
            v-for="item in runModesIncludeAll"
            :key="item.id"
            :value="item.id"
            :label="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleFormQuery()" type="primary">查 询</el-button>
        <el-button @click="resetQueryForm()">重 置</el-button>
      </el-form-item>
    </el-form>
    <div class="pagination-table-button-container">
      <el-button @click="handleAdd" type="primary">新 增</el-button>
      <el-button type="primary" @click="handleDelete()" :disabled="!tableSelectedIds.length">批量删除</el-button>
      <el-button type="primary" @click="handleImport()">导 入</el-button>
      <el-button type="primary" @click="handleExport()">导 出</el-button>
    </div>
    <div class="pagination-table-container">
      <el-table ref="table"
                :data="tableData"
                border highlight-current-row
                style="width: 100%"
                v-loading="loading"
                element-loading-text="努力加载中..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                @selection-change="handleTableSelectionChange"
                @current-change="handleTableCurrentChange">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column label="运行模式" prop="runMode" width="80">
          <template slot-scope="scope">{{ getNameById(scope.row.runMode, $type.runModes) }}</template>
        </el-table-column>
        <el-table-column label="抓拍方式" prop="captureMethod" width="80">
          <template slot-scope="scope">{{ getNameById(scope.row.captureMethod, $type.captureMethods) }}</template>
        </el-table-column>
        <el-table-column label="流打开模式" prop="streamOpenMode" width="120">
          <template slot-scope="scope">{{ getNameById(scope.row.streamOpenMode, $type.streamOpenModes) }}</template>
        </el-table-column>
        <el-table-column label="抓拍间隔(秒)" prop="captureInterval" width="100">
          <template slot-scope="scope">
            {{ scope.row.captureInterval/1000 }}
          </template>
        </el-table-column>
        <el-table-column label="抓拍目录" prop="captureDir" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="文件格式" prop="pictureFormat" width="80">
          <template slot-scope="scope">{{ getNameById(scope.row.pictureFormat, $type.pictureFormats) }}</template>
        </el-table-column>
        <el-table-column label="最大抓拍次数" prop="maxCaptureTimes" width="100">
          <template slot-scope="scope">
            {{
            scope.row.maxCaptureTimes === 0 ? '不限': scope.row.maxCaptureTimes
            }}
          </template>D
        </el-table-column>
        <el-table-column label="运行时刻表" prop="runScheduleId" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{
            !scope.row.runScheduleId ? '无': getNameById(scope.row.runScheduleId, $globalData.runSchedules)
            }}
          </template>
        </el-table-column>
        <el-table-column label="抓拍服务" prop="serviceId" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{
            !scope.row.serviceId ? '全部': getNameById(scope.row.serviceId, servicesIncludeAll)
            }}
          </template>
        </el-table-column>
        <el-table-column label="适用范围" prop="scope" :show-overflow-tooltip="true">
          <template slot-scope="scope">{{ getNameById(scope.row.scope, $type.captureTaskScopes) }}</template>
        </el-table-column>
        <el-table-column label="状态" prop="runState" width="80">
          <template slot-scope="scope">
            <el-tag :type="!scope.row.runState ? 'primary':'warning'">{{!scope.row.runState ? '停止':'活动' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <el-button
              class="col-btn"
              type="text"
              icon="el-icon-edit"
              @click="handleModify(scope.row)"
            >修改
            </el-button>
            <el-button
              class="col-btn"
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="handleCurrentPageChange"
        @size-change="handlePageSizeChange"
        :current-page.sync="tableQueryParams.pageNum"
        :page-sizes="[5, 10, 15, 20, 30, 50, 100]"
        :page-size.sync="tableQueryParams.pageSize"
        prev-text="上一页"
        next-text="下一页"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotalRow">
      </el-pagination>
    </div>
    <!--视频节点内容-->
    <div>
      <el-tabs v-model="activeTabName">
        <el-tab-pane label="视频节点" name="0">
          <div class="pagination-table-button-container">
            <el-button type="primary" @click="handleAddStreamNode">新 增</el-button>
            <el-button type="primary" @click="handleDeleteStreamNode" :disabled="!streamNodeTableSelectedIds.length">批量删除</el-button>
          </div>
          <div class="pagination-table-container">
            <el-table
              ref="streamNodeTable"
              :data="streamNodeTableData"
              border
              style="width: 100%;min-height: 120px"
              v-loading="streamNodeTableLoading"
              element-loading-text="努力加载中..."
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255, 255, 255, 0.8)"
              @selection-change="handleStreamNodeTableSelectionChange">
              <el-table-column type="selection" width="40"></el-table-column>
              <el-table-column label="序号" type="index" width="60"></el-table-column>
              <el-table-column label="名称" prop="name"></el-table-column>
              <el-table-column label="监控设备" prop="encoderId">
                <template slot-scope="scope"> {{getNameById(scope.row.encoderId, $globalData.encoders)}} </template>
              </el-table-column>
              <el-table-column label="通道号" prop="encoderVideoInputNum"></el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button
                    class="col-btn"
                    type="text"
                    icon="el-icon-delete"
                    @click="handleDeleteStreamNode(scope.row)"
                  >删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              @current-change="handleStreamNodeCurrentPageChange"
              @size-change="handleStreamNodePageSizeChange"
              :current-page.sync="streamNodeTableQueryParams.pageNum"
              :page-sizes="[5, 10, 20]"
              :page-size.sync="streamNodeTableQueryParams.pageSize"
              prev-text="上一页"
              next-text="下一页"
              layout="total, sizes, prev, pager, next, jumper"
              :total="streamNodeTableTotalRow">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!--新增或修改抓拍任务-->
    <el-dialog
      :title="modalForm.id ? '修改抓拍任务' : '新增抓拍任务'"
      :visible="modalOpen"
      :append-to-body="true"
      width="1000px"
      :before-close="handleModalCancel"
    >
      <el-form ref="modalForm" inline class="capture-task-form" :model="modalForm" :rules="formRules" labelWidth="120px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="modalForm.name" placeholder="请输入名称" clearable :style="{width: '300px'}"></el-input>
        </el-form-item>
        <el-form-item label="运行模式" prop="runMode" >
          <el-select v-model="modalForm.runMode" placeholder="请选择运行模式" :style="{width: '300px'}">
            <el-option v-for="item in $type.runModes" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="抓拍方式" prop="captureMethod">
          <el-select v-model="modalForm.captureMethod" placeholder="请选择抓拍方式" :style="{width: '300px'}">
            <el-option v-for="item in $type.captureMethods" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="流打开模式" prop="streamOpenMode">
          <el-select v-model="modalForm.streamOpenMode" placeholder="请选择流打开模式" :style="{width: '300px'}">
            <el-option v-for="item in $type.streamOpenModes" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="抓拍间隔" prop="captureInterval">
          <el-input v-model.number="modalForm.captureInterval" class="slot-input" placeholder="请输入抓拍间隔" :style="{width: '300px'}">
            <template slot="append">秒</template>
          </el-input>
        </el-form-item>
        <el-form-item label="抓拍目录" prop="captureDir">
          <el-input v-model.number="modalForm.captureDir" class="slot-input" placeholder="请输入抓拍目录" :style="{width: '300px'}">
          </el-input>
        </el-form-item>
        <el-form-item label="文件格式" prop="pictureFormat">
          <el-select v-model="modalForm.pictureFormat" placeholder="请选择抓拍文件格式" :style="{width: '300px'}">
            <el-option v-for="item in $type.pictureFormats" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最大抓拍次数" prop="maxCaptureTimes">
          <el-input v-model.number="modalForm.maxCaptureTimes" placeholder="请输入最大抓拍次数（0-不限）" :style="{width: '300px'}">
            <template slot="append">次</template>
          </el-input>
        </el-form-item>
        <el-form-item label="运行时刻表" prop="runScheduleId">
          <el-select v-model="modalForm.runScheduleId" placeholder="请选择运行时刻表" :style="{width: '300px'}">
            <el-option v-for="item in runSchedulesIncludeNone" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="抓拍服务" prop="serviceId">
          <el-select v-model="modalForm.serviceId" placeholder="请选择抓拍服务" :style="{width: '300px'}">
            <el-option v-for="item in servicesIncludeAll" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="适用范围" prop="scope">
          <el-select v-model="modalForm.scope" placeholder="请选择适用范围" :style="{width: '300px'}">
            <el-option v-for="item in $type.captureTaskScopes" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleModalSubmit" type="primary">确定</el-button>
        <el-button @click="handleModalCancel">取消</el-button>
      </div>
    </el-dialog>

    <!--新增视频节点-->
    <add-stream-node v-if="streamNodeModalOpen" :modalOpen="streamNodeModalOpen" :capture-task-id="tableCurrentId"  @submit="handleStreamNodeModalSubmit" @cancel="handleStreamNodeModalCancel"></add-stream-node>
  </div>
</template>

<script type="text/ecmascript-6">
import CaptureTask from './CaptureTask.js'

export default CaptureTask
</script>

<style lang="scss">
// @import "CaptureTask";
</style>



// WEBPACK FOOTER //
// src/views/system/captureTask/CaptureTask.vue